import React, { useEffect, useContext } from "react";

// Context
import AppContext from "./AppContext";

// Css
import "./Edit.css";

// Scripts
import rgbToHex from "./scripts/rgbToHex";

// Components
import TextEditor from "./TextEditor";
import ToolBar from "./ToolBar";
import UnderMaintenance from "./UnderMaintenance";
import DoneToggle from "./DoneToggle";
import Output from "./Output";
import Ads from "./Ads";
import VideoReward from "./VideoReward";

// Global Variables
let checker, previousForeColor;
let prevToolState = {
  bold: false,
  italic: false,
  underline: false,
  strikeThrough: false,
};

function Edit() {
  const { appContext, setAppContext } = useContext(AppContext);

  useEffect(() => {
    if (appContext.toolBarOn) {
      document.querySelector("._Ads_").style["display"] = "none";
    } else {
      document.querySelector("._Ads_").style["display"] = "flex";
    }
  }, [appContext.toolBarOn]);

  useEffect(() => {
    if (checker) clearTimeout(checker);
    const { foreColor, foreColorState, hasContent } = appContext;

    checker = setInterval(() => {
      const currentToolState = {
        bold: document.queryCommandState("bold"),
        italic: document.queryCommandState("italic"),
        underline: document.queryCommandState("underline"),
        strikeThrough: document.queryCommandState("strikeThrough"),
      };
      if (prevToolState == currentToolState) {
        console.log("hello");
      }
      const tools = ["bold", "italic", "underline", "strikeThrough"];
      tools.forEach((type) => {
        const smallTools = document.querySelector(`.small-tools__${type}`);
        const normalTool = document.querySelector(`#tool__${type}`);
        if (document.queryCommandState(type)) {
          if (smallTools)
            smallTools.classList.add("small-tools__button-selected");
          if (normalTool) normalTool.classList.add("tool-selected");
        } else {
          if (smallTools)
            smallTools.classList.remove("small-tools__button-selected");
          if (normalTool) normalTool.classList.remove("tool-selected");
        }
      });

      const currentForeColor = document.queryCommandValue("foreColor");
      if (currentForeColor != previousForeColor) {
        previousForeColor = currentForeColor;
        const fontColorRGB = document
          .queryCommandValue("foreColor")
          .replace(/[^0-9,]/g, "")
          .split(",")
          .map(Number);

        if (fontColorRGB.length == 3) {
          const fontColor = rgbToHex(
            fontColorRGB[0],
            fontColorRGB[1],
            fontColorRGB[2]
          );
          const isTooDark = (hexcolor) => {
            let r = parseInt(hexcolor.substr(1, 2), 16);
            let g = parseInt(hexcolor.substr(3, 2), 16);
            let b = parseInt(hexcolor.substr(4, 2), 16);
            let yiq = (r * 299 + g * 587 + b * 114) / 1000;
            return yiq < 40 ? false : true;
          };
          const isDarkBorder = isTooDark(fontColor) ? "dark" : "light";

          setAppContext((prev) => ({
            ...prev,
            foreColor: fontColor,
            foreColorState: true,
          }));

          document
            .querySelectorAll(".color")
            .forEach((element) => (element.className = "color"));
          const colorSelector = document.getElementById(
            `color-${fontColor.replace("#", "")}`
          );

          if (colorSelector != null)
            colorSelector.classList.add(`color-picked-${isDarkBorder}`);
        }
      }
      if (document.querySelector(".textEditor")) {
        if (
          !/^\s*$/.test(document.querySelector(".textEditor").innerText) &&
          hasContent == false
        ) {
          setAppContext((prev) => ({
            ...prev,
            hasContent: true,
          }));
        } else if (
          /^\s*$/.test(document.querySelector(".textEditor").innerText) &&
          hasContent
        ) {
          setAppContext((prev) => ({
            ...prev,
            hasContent: false,
          }));
        }
      }
    }, 1);
  }, [appContext]);
  return (
    <div className="edit">
      <TextEditor />
      <ToolBar />
      <DoneToggle />
      <Output />
      <Ads />
    </div>
  );
}

export default Edit;
